import script from "./goalList.vue?vue&type=script&setup=true&lang=js"
export * from "./goalList.vue?vue&type=script&setup=true&lang=js"

import "./goalList.vue?vue&type=style&index=0&id=79287f2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79287f2c"]])

export default __exports__